export const usdc = {
    base: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    baseSepolia: '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
} as const
